import {useSearchParams} from "react-router-dom";

const useQueryParamsHelper = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const setQueryParams = (params: Record<string, string | null>) => {
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev);
            Object.entries(params).forEach(([key, value]) => {
                if (value === null) {
                    newParams.delete(key);
                } else {
                    newParams.set(key, value);
                }
            });
            return newParams;
        });
    };

    const deleteSearchParams = (key: string) => {
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev);
            newParams.delete(key);
            return newParams;
        });
    };

    const getQueryParams = (key?: string): string | null => key?searchParams.get(key):searchParams.toString();

    return {setQueryParams, getQueryParams, deleteSearchParams};
}

export default useQueryParamsHelper
